import {logout} from "../redux-store/auth";
import {clearInstallations} from "../redux-store/installations";
import {clearGlobalState} from "../redux-store/globalData";
import {store} from "../redux-store/store";

export const checkUserPermissions = (userInfo) => {

    if (userInfo?.role === "ADMIN" || userInfo?.role === "SUPERUSER") {
        return true
    } else return !!(userInfo?.authorities && userInfo?.authorities[0]?.authority === "ROLE_ADMIN" || userInfo?.authorities && userInfo?.authorities[0]?.authority === "ROLE_SUPERUSER");
}

export const checkSuperUser = (userInfo) => {

    if (userInfo?.role === "SUPERUSER") {
        return true
    } else return !!(userInfo?.authorities && userInfo?.authorities[0]?.authority === "ROLE_SUPERUSER");
}

export const checkUserViewer = (userInfo) => {
    if (userInfo?.role === "VIEWER") {
        return true
    } else return !!(userInfo?.authorities && userInfo?.authorities[0]?.authority === "ROLE_VIEWER");
}

export const logOutUser = () => {
    store.dispatch(logout())
    store.dispatch(clearInstallations())
    store.dispatch(clearGlobalState())
}